import React from 'react';
import styles from './AIAssistanceBackdrop.module.css';

/** Decorative layers for the AI Assistance full-page section */
export default function AIAssistanceBackdrop() {
  return (
    <div className={styles.wrap} aria-hidden="true">
      <div className={styles.glowLayer} />
      <div className={styles.meshLayer} />
      <svg
        className={styles.networkSvg}
        viewBox="0 0 720 640"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="ai-line" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fff" stopOpacity="0" />
            <stop offset="40%" stopColor="#fff" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#edc917" stopOpacity="0.2" />
          </linearGradient>
          <radialGradient id="ai-node-core" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#edc917" stopOpacity="0.45" />
            <stop offset="100%" stopColor="#edc917" stopOpacity="0" />
          </radialGradient>
          <filter id="ai-soft-glow" x="-40%" y="-40%" width="180%" height="180%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g opacity="0.9">
          <path
            d="M120 420 Q 220 360 320 400 T 520 340 T 640 280"
            fill="none"
            stroke="url(#ai-line)"
            strokeWidth="1.2"
          />
          <path
            d="M80 480 L 200 400 L 340 440 L 480 360 L 600 400"
            fill="none"
            stroke="#fff"
            strokeOpacity="0.06"
            strokeWidth="1"
          />
          <path
            d="M200 400 L 340 280 L 480 360 L 340 440 Z"
            fill="none"
            stroke="#fff"
            strokeOpacity="0.05"
            strokeWidth="1"
          />
          <circle cx="200" cy="400" r="5" fill="#fff" fillOpacity="0.2" />
          <circle cx="340" cy="280" r="6" fill="#edc917" fillOpacity="0.55" filter="url(#ai-soft-glow)" />
          <circle cx="480" cy="360" r="5" fill="#fff" fillOpacity="0.15" />
          <circle cx="340" cy="440" r="5" fill="#fff" fillOpacity="0.12" />
          <circle cx="600" cy="400" r="4" fill="#fff" fillOpacity="0.1" />
          <circle cx="520" cy="200" r="56" fill="url(#ai-node-core)" opacity="0.35" />
          <circle cx="520" cy="200" r="8" fill="#edc917" fillOpacity="0.5" />
        </g>
        <g fill="#fff" fillOpacity="0.06">
          {Array.from({ length: 14 * 10 }, (_, k) => {
            const col = k % 14;
            const row = Math.floor(k / 14);
            return (
              <circle key={`d-${k}`} cx={40 + col * 48} cy={80 + row * 44} r="1.1" />
            );
          })}
        </g>
        <g opacity="0.35" transform="translate(380 120)">
          <rect x="0" y="0" width="200" height="120" rx="10" fill="#0d0e12" stroke="#fff" strokeOpacity="0.08" />
          <rect x="16" y="20" width="72" height="6" rx="2" fill="#fff" fillOpacity="0.1" />
          <rect x="16" y="36" width="120" height="5" rx="2" fill="#fff" fillOpacity="0.06" />
          <rect x="16" y="52" width="100" height="5" rx="2" fill="#fff" fillOpacity="0.05" />
          <rect x="16" y="76" width="88" height="28" rx="6" fill="#edc917" fillOpacity="0.12" />
        </g>
      </svg>
      <div className={styles.cornerArc} />
    </div>
  );
}
